import router from './index'
import NProgress from 'nprogress'

import {
  LoginStatusEnum,
  UserModule,
} from '@/store/modules/user'
import { getLoginStatus } from '@/utils/auth'
import { Message as ElMessage } from 'element-ui'
import { redirectToLogin } from '@/utils'

// 参考流程图: https://www.processon.com/view/link/6115d8e1e0b34d0b1a54329d
false && router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const loginStatus = await getLoginStatus()
  if (loginStatus === LoginStatusEnum.Login) {
    if (to.name === 'Login') {
      next({ path: '/' })
    } else {
      next()
      // const currentRole = UserModule.userInfo?.role ?? '' // 当前用户角色
      // const hasPermission = Array.isArray(to.meta?.roles) && to.meta?.roles.includes(currentRole)
      // if (to.meta?.inWhiteList || hasPermission) {
      //   next()
      // } else{
      //   next({ name: '404' }) // 跳到404页面
      // }
    }
  } else if (loginStatus === LoginStatusEnum.OtherUserHasLoginFromOtherTab) {
    if (to.meta?.inWhiteList) {
      next()
    } else {
      window.location.reload()
    }
  } else {
    // 状态是下面中的一种
    // LoginStatusEnum.TokenInvalid
    // LoginStatusEnum.NeverLogin
    // LoginStatusEnum.LogoutFromOtherTab
    if (to.meta?.inWhiteList) {
      next()
    } else {
      if (loginStatus === LoginStatusEnum.TokenInvalid || loginStatus === LoginStatusEnum.LogoutFromOtherTab) {
        ElMessage.info('登陆已失效，需要重新登录')
      }
      redirectToLogin()
    }
  }
})

router.afterEach((to) => {
  // set page title
  document.title = (to.meta?.title ? `${to.meta.title}` : '')
  NProgress.done()
})
